  (function () {
    const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

    const DISCOUNT_CODES = {
      bonus1: 'PS-BONUS-5',
      bonus2: 'PS-BONUS-10'
    };

    const CHECKOUT_URL = '/checkout';
    const PURCHASE_PROCESS_URL = '/pages/purchase-process';
    const FLOW_STORAGE_KEY = 'ps_cart_bonus_flow_v1';

    /*
      IMPORTANT:
      These arrays are for discount-code safety, not only display.
      Keep every product included inside each Shopify discount code here.
      This prevents Shopify from discounting a normal product-page line when the same product is already in cart.
    */
    const UPSELLS_PER_BONUS = 2;
    const RECOMMENDATION_LIMIT = 10;
    const RECOMMENDATION_INTENT = 'related';

    const drawer = document.getElementById('psCartDrawer');
    if (!drawer) return;

    const cartItemsContainer = drawer.querySelector('[data-ps-cart-items]');
    const cartCountEls = drawer.querySelectorAll('[data-ps-cart-count]');
    const footerCountEl = drawer.querySelector('[data-ps-footer-count]');
    const subtotalEl = drawer.querySelector('[data-ps-cart-subtotal]');
    const decorateError = drawer.querySelector('[data-ps-decorate-error]');
    const flowError = drawer.querySelector('[data-ps-checkout-flow-error]');
    const upsellsWrap = drawer.querySelector('[data-ps-upsells-wrap]');
    const bonus1Section = drawer.querySelector('[data-ps-bonus-section="1"]');
    const bonus2Section = drawer.querySelector('[data-ps-bonus-section="2"]');
    const checkoutButton = drawer.querySelector('[data-ps-checkout]');
    const progressBar = drawer.querySelector('[data-ps-cart-progress]');
    const bonusTabs = drawer.querySelectorAll('[data-ps-tab]');
    const bonus1Target = drawer.querySelector('[data-ps-upsell-target="1"]');
    const bonus2Target = drawer.querySelector('[data-ps-upsell-target="2"]');
    const decorateQuestion = drawer.querySelector('[data-ps-decorate-question]');

    const MARBLE_TAG = 'Marble Falls Mustangs';
    const DONATION_TAG = 'Donation Marble False';
    const drawerProductTagCache = {};

    let lastUpsellRecommendationSignature = '';
    let upsellRequestId = 0;

    let lastCart = null;

    window.openPsCartDrawer = async function () {
      await refreshCart(true);
    };

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function normalize(value) {
      return String(value || '').trim().toLowerCase();
    }

    function buildStorePath(path) {
      const cleanRoot = root.endsWith('/') ? root.slice(0, -1) : root;
      const cleanPath = path.startsWith('/') ? path : '/' + path;

      if (cleanRoot === '') return cleanPath;

      return cleanRoot + cleanPath;
    }

    function buildDiscountUrl(codes, redirectPath) {
      if (!codes.length) {
        return buildStorePath(redirectPath);
      }

      const codePath = codes.map(encodeURIComponent).join(',');
      const redirect = buildStorePath(redirectPath);

      return root + 'discount/' + codePath + '?redirect=' + encodeURIComponent(redirect);
    }

    function openDrawer() {
      document.body.classList.add('ps-cart-open');
      drawer.setAttribute('aria-hidden', 'false');
    }

    function closeDrawer() {
      document.body.classList.remove('ps-cart-open');
      drawer.setAttribute('aria-hidden', 'true');
    }

    document.addEventListener(
    'click',
    function (event) {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      const closeTrigger = target.closest('[data-ps-cart-close], .ps-cart-close');

      if (!closeTrigger) return;

      event.preventDefault();
      event.stopPropagation();

      closeDrawer();
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeDrawer();
    }
  });

    async function getCart() {
      const res = await fetch(root + 'cart.js', {
        headers: {
          Accept: 'application/json'
        }
      });

      return await res.json();
    }

    function getItemHandle(item) {
      if (item.handle) return item.handle;

      const match = (item.url || '').match(/\/products\/([^/?#]+)/);
      return match ? match[1] : null;
    }

    async function getItemTags(item) {
      const handle = getItemHandle(item);

      if (!handle) return [];

      if (drawerProductTagCache[handle]) {
        return drawerProductTagCache[handle];
      }

      drawerProductTagCache[handle] = fetch(
        buildStorePath('/products/' + encodeURIComponent(handle) + '.js')
      )
        .then(function (response) {
          if (!response.ok) return [];
          return response.json();
        })
        .then(function (product) {
          return Array.isArray(product.tags) ? product.tags : [];
        })
        .catch(function () {
          return [];
        });

      return drawerProductTagCache[handle];
    }

    async function updateDecorateQuestion(cart) {
      if (!decorateQuestion) return;

      const tagLists = await Promise.all(
        (cart.items || []).map(function (item) {
          return getItemTags(item);
        })
      );

      const hasOtherProducts = tagLists.some(function (tags) {
        return (
          tags.indexOf(MARBLE_TAG) === -1 &&
          tags.indexOf(DONATION_TAG) === -1
        );
      });

      decorateQuestion.hidden = !hasOtherProducts;

      if (!hasOtherProducts) {
        drawer
          .querySelectorAll('input[name="ps_decorate_choice"]')
          .forEach(function (input) {
            input.checked = false;
          });

        if (decorateError) {
          decorateError.style.display = 'none';
        }
      }
    }

    function getItemOptions(item) {
      if (!item.options_with_values || !item.options_with_values.length) return '';

      return item.options_with_values
        .filter(function (option) {
          const name = normalize(option.name);
          const value = normalize(option.value);

          if (name === 'title' && value === 'default title') return false;
          if (value === 'default title') return false;

          return true;
        })
        .map(function (option) {
          return `<span>${option.name}: ${option.value}</span>`;
        })
        .join('');
    }

    function isDrawerUpsellLine(item, tierName) {
      const properties = item.properties || {};

      if (tierName) {
        return (
          properties['_ps_upsell_source'] === 'cart_drawer' &&
          properties['_ps_bonus_tier'] === tierName
        );
      }

      return properties['_ps_upsell_source'] === 'cart_drawer';
    }

    function getOriginalCartSignature(cart) {
      if (!cart || !cart.items || !cart.items.length) return '';

      return cart.items
        .filter(function (item) {
          return !isDrawerUpsellLine(item);
        })
        .map(function (item) {
          return [item.handle, item.variant_id].join(':');
        })
        .sort()
        .join('|');
    }

    function getSavedFlowState() {
      try {
        return JSON.parse(sessionStorage.getItem(FLOW_STORAGE_KEY) || '{}');
      } catch (err) {
        return {};
      }
    }

    function saveFlowState(state) {
      sessionStorage.setItem(FLOW_STORAGE_KEY, JSON.stringify(state));
    }

    function resetFlowState() {
      sessionStorage.removeItem(FLOW_STORAGE_KEY);
    }

    function cartHasTierUpsell(cart, tierName) {
      return Boolean(
        cart &&
        cart.items &&
        cart.items.some(function (item) {
          return isDrawerUpsellLine(item, tierName);
        })
      );
    }

    function getFlowStateForCart(cart) {
      const hasCartItems = Boolean(cart && cart.items && cart.items.length);

      if (!hasCartItems) {
        resetFlowState();
        return {
          hasCartItems: false,
          bonus1Done: false,
          bonus2Done: false
        };
      }

      const signature = getOriginalCartSignature(cart) || 'upsell-only-cart';
      let saved = getSavedFlowState();

      if (saved.signature !== signature) {
        saved = {
          signature: signature,
          bonus1Done: false,
          bonus2Done: false
        };
        saveFlowState(saved);
      }

      return {
        hasCartItems: true,
        bonus1Done: Boolean(saved.bonus1Done || cartHasTierUpsell(cart, 'Bonus 1')),
        bonus2Done: Boolean(saved.bonus2Done || cartHasTierUpsell(cart, 'Bonus 2')),
        signature: signature
      };
    }

    function completeBonusStep(step) {
      if (!lastCart || !lastCart.items || !lastCart.items.length) return;

      const signature = getOriginalCartSignature(lastCart) || 'upsell-only-cart';
      const saved = getSavedFlowState();

      const nextState = {
        signature: signature,
        bonus1Done: Boolean(saved.bonus1Done),
        bonus2Done: Boolean(saved.bonus2Done)
      };

      if (String(step) === '1') {
        nextState.bonus1Done = true;
      }

      if (String(step) === '2') {
        nextState.bonus2Done = true;
      }

      saveFlowState(nextState);
      updateFlowUI(lastCart);

      if (String(step) === '1' && bonus2Section) {
        bonus2Section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    function showFlowError(message) {
      if (!flowError) return;

      flowError.textContent = message;
      flowError.style.display = 'block';
    }

    function hideFlowError() {
      if (flowError) {
        flowError.style.display = 'none';
      }
    }

    function updateFlowUI(cart) {
      lastCart = cart;

      const flow = getFlowStateForCart(cart);

      drawer.classList.toggle('ps-cart-empty', !flow.hasCartItems);

      if (upsellsWrap) {
        upsellsWrap.hidden = !flow.hasCartItems;
      }

      if (bonus1Section) {
        bonus1Section.hidden = !flow.hasCartItems;
      }

      if (bonus2Section) {
        bonus2Section.hidden = !flow.hasCartItems || !flow.bonus1Done;
      }

      if (!flow.hasCartItems) {
        if (checkoutButton) {
          checkoutButton.classList.add('is-locked');
          checkoutButton.setAttribute('aria-disabled', 'true');
        }
        if (progressBar) progressBar.style.width = '0%';
        hideFlowError();
        return;
      }

      if (checkoutButton) {
        checkoutButton.classList.toggle('is-locked', !flow.bonus2Done);
        checkoutButton.setAttribute('aria-disabled', flow.bonus2Done ? 'false' : 'true');
      }

      if (progressBar) {
        if (flow.bonus2Done) {
          progressBar.style.width = '100%';
        } else if (flow.bonus1Done) {
          progressBar.style.width = '66%';
        } else {
          progressBar.style.width = '33%';
        }
      }

      bonusTabs.forEach(function (tab) {
        const tabStep = tab.getAttribute('data-ps-tab');
        tab.classList.remove('is-active', 'is-complete', 'is-locked');

        if (tabStep === '1') {
          tab.classList.add(flow.bonus1Done ? 'is-complete' : 'is-active');
        }

        if (tabStep === '2') {
          if (!flow.bonus1Done) {
            tab.classList.add('is-locked');
          } else {
            tab.classList.add(flow.bonus2Done ? 'is-complete' : 'is-active');
          }
        }
      });
    }

    function getDiscountCodesFromCart(cart) {
      const codes = [];

      if (
        cart.items.some(function (item) {
          return isDrawerUpsellLine(item, 'Bonus 1');
        })
      ) {
        codes.push(DISCOUNT_CODES.bonus1);
      }

      if (
        cart.items.some(function (item) {
          return isDrawerUpsellLine(item, 'Bonus 2');
        })
      ) {
        codes.push(DISCOUNT_CODES.bonus2);
      }

      return codes;
    }

    async function getDiscountRedirectUrl(defaultRedirectPath) {
      const cart = await getCart();
      const codes = getDiscountCodesFromCart(cart);

      return buildDiscountUrl(codes, defaultRedirectPath);
    }

    async function applyDiscountCodesToCart(codes) {
    const discountValue = codes && codes.length ? codes.join(',') : '';

    const res = await fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        discount: discountValue
      })
    });

    if (!res.ok) {
      throw new Error('Discount apply failed');
    }

    return await res.json();
  }

  async function redirectWithAppliedDiscounts(defaultRedirectPath) {
    const cart = await getCart();
    const codes = getDiscountCodesFromCart(cart);

    try {
      await applyDiscountCodesToCart(codes);
      window.location.href = buildStorePath(defaultRedirectPath);
    } catch (err) {
      console.error('Cart discount update failed, using fallback discount URL:', err);

      const fallbackUrl = buildDiscountUrl(codes, defaultRedirectPath);
      window.location.href = fallbackUrl;
    }
  }

  // Start Test
  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function priceToCents(value) {
    if (value == null) return 0;

    const raw = String(value);
    const number = Number(raw);

    if (!Number.isFinite(number)) return 0;

    return raw.includes('.') ? Math.round(number * 100) : Math.round(number);
  }

  function getOptionNames(product) {
    return (product.options || []).map(function (option) {
      return typeof option === 'string' ? option : option.name || '';
    });
  }

  function getOptionIndex(product, keyword) {
    const optionNames = getOptionNames(product);

    return optionNames.findIndex(function (name) {
      return normalize(name).includes(keyword);
    });
  }

  function getVariantOptionValue(variant, index) {
    return (
      variant['option' + (index + 1)] ||
      (variant.options && variant.options[index]) ||
      ''
    );
  }

  function getAvailableVariants(product) {
    const variants = Array.isArray(product.variants) ? product.variants : [];

    return variants.filter(function (variant) {
      return variant && variant.id && variant.available !== false;
    });
  }

  function getProductImage(product, variant) {
    let image =
      product.featured_image ||
      (product.images && product.images[0]) ||
      (variant && variant.featured_image) ||
      '';

    if (image && typeof image === 'object') {
      image = image.src || image.url || '';
    }

    return image || '';
  }

  function getColorLine(product, variant) {
    const colorIndex = getOptionIndex(product, 'color');

    if (colorIndex === -1) return '';

    const colorValue = getVariantOptionValue(variant, colorIndex);

    if (!colorValue) return '';

    return `<p class="ps-upsell-option">Color: ${escapeHtml(colorValue)}</p>`;
  }

  function buildVariantSelect(product, selectedVariant) {
    const sizeIndex = getOptionIndex(product, 'size');
    const variants = Array.isArray(product.variants) ? product.variants : [];

    return `
      <select class="ps-upsell-variant ps-upsell-variant--hidden">
        ${variants
          .map(function (variant) {
            const variantSizeValue = sizeIndex > -1 ? getVariantOptionValue(variant, sizeIndex) : '';
            const selected = String(variant.id) === String(selectedVariant.id) ? 'selected' : '';
            const disabled = variant.available === false ? 'disabled' : '';
            const title = variant.title || 'Default Title';

            return `
              <option
                value="${escapeHtml(variant.id)}"
                data-size-value="${escapeHtml(variantSizeValue)}"
                ${selected}
                ${disabled}
              >
                ${escapeHtml(title)}${variant.available === false ? ' - Sold out' : ''}
              </option>
            `;
          })
          .join('')}
      </select>
    `;
  }

  function buildSizeBoxes(product, selectedVariant) {
    const sizeIndex = getOptionIndex(product, 'size');

    if (sizeIndex === -1) return '';

    const variants = Array.isArray(product.variants) ? product.variants : [];
    const selectedSizeValue = getVariantOptionValue(selectedVariant, sizeIndex);
    const sizeValues = [];

    variants.forEach(function (variant) {
      const sizeValue = getVariantOptionValue(variant, sizeIndex);

      if (sizeValue && !sizeValues.includes(sizeValue)) {
        sizeValues.push(sizeValue);
      }
    });

    if (!sizeValues.length) return '';

    return `
      <div class="ps-upsell-size-boxes" data-ps-size-boxes>
        ${sizeValues
          .map(function (sizeValue) {
            const matchingAvailableVariant = variants.find(function (variant) {
              return (
                getVariantOptionValue(variant, sizeIndex) === sizeValue &&
                variant.available !== false
              );
            });

            const variantId = matchingAvailableVariant ? matchingAvailableVariant.id : '';
            const disabled = matchingAvailableVariant ? '' : 'disabled';
            const active = sizeValue === selectedSizeValue ? ' is-active' : '';

            return `
              <button
                type="button"
                class="ps-upsell-size-box${active}"
                data-ps-size-box
                data-variant-id="${escapeHtml(variantId)}"
                ${disabled}
              >
                ${escapeHtml(sizeValue)}
              </button>
            `;
          })
          .join('')}
      </div>
    `;
  }

  function renderUpsellCard(product, step, discountPercent) {
    const availableVariants = getAvailableVariants(product);

    if (!availableVariants.length) return '';

    const variant = availableVariants[0];
    const originalPrice = priceToCents(variant.price || product.price);
    const discountedPrice = Math.round(originalPrice * (100 - discountPercent) / 100);
    const image = getProductImage(product, variant);

    return `
      <article class="ps-upsell-card" data-ps-upsell-product-handle="${escapeHtml(product.handle)}">
        <div class="upsellText">
          <div class="ps-upsell-card__image">
            ${image ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(product.title)}">` : ''}
          </div>

          <h4>${escapeHtml(product.title)}</h4>

          ${getColorLine(product, variant)}

          <div class="ps-upsell-price">
            <strong>${formatMoney(discountedPrice)}</strong>
            <s>${formatMoney(originalPrice)}</s>
          </div>

          ${buildVariantSelect(product, variant)}

          ${buildSizeBoxes(product, variant)}
        </div>

        <div class="upsellBtns">
          <div class="ps-upsell-qty">
            <button type="button" data-ps-upsell-minus>−</button>
            <input type="number" value="1" min="1">
            <button type="button" data-ps-upsell-plus>+</button>
          </div>

          <button
            type="button"
            class="ps-upsell-add"
            data-ps-upsell-add
            data-bonus-step="${step}"
            data-bonus-tier="Bonus ${step}"
            data-discount="${discountPercent}"
          >
            ADD TO CART
          </button>
        </div>
      </article>
    `;
  }

  async function fetchJson(url) {
    const res = await fetch(url, {
      headers: {
        Accept: 'application/json'
      }
    });

    if (!res.ok) {
      throw new Error('Request failed: ' + url);
    }

    return await res.json();
  }

  async function fetchProductByHandle(handle) {
    return await fetchJson(buildStorePath('/products/' + encodeURIComponent(handle) + '.js'));
  }

  async function fetchRecommendationsForProduct(productId) {
    const url =
      buildStorePath('/recommendations/products.json') +
      '?product_id=' +
      encodeURIComponent(productId) +
      '&limit=' +
      RECOMMENDATION_LIMIT +
      '&intent=' +
      encodeURIComponent(RECOMMENDATION_INTENT);

    try {
      const data = await fetchJson(url);
      const products = Array.isArray(data.products) ? data.products : [];

      const hydratedProducts = await Promise.all(
        products.map(async function (product) {
          if (!product || !product.handle) return null;

          try {
            return await fetchProductByHandle(product.handle);
          } catch (err) {
            console.warn('Could not hydrate recommended product:', product.handle, err);
            return product;
          }
        })
      );

      return hydratedProducts.filter(Boolean);
    } catch (err) {
      console.error('Recommendation API failed for product_id:', productId, err);
      return [];
    }
  }

  async function getRelatedProductsForCart(cart) {
    const items = cart && Array.isArray(cart.items) ? cart.items : [];

    const originalItems = items.filter(function (item) {
      return !isDrawerUpsellLine(item);
    });

    if (!originalItems.length) return [];

    const currentHandles = new Set(
      items.map(function (item) {
        return normalize(item.handle);
      })
    );

    const productIds = [
      ...new Set(
        originalItems
          .map(function (item) {
            return item.product_id;
          })
          .filter(Boolean)
      )
    ].slice(0, 3);

    const seenHandles = new Set();
    const finalProducts = [];

    for (const productId of productIds) {
      const recommendations = await fetchRecommendationsForProduct(productId);

      recommendations.forEach(function (product) {
        const handle = normalize(product.handle);

        if (!handle) return;
        if (seenHandles.has(handle)) return;
        if (currentHandles.has(handle)) return;
        if (!getAvailableVariants(product).length) return;

        seenHandles.add(handle);
        finalProducts.push(product);
      });

      if (finalProducts.length >= UPSELLS_PER_BONUS * 2) {
        return finalProducts.slice(0, UPSELLS_PER_BONUS * 2);
      }
    }

    return finalProducts.slice(0, UPSELLS_PER_BONUS * 2);
  }

  async function renderDynamicUpsells(cart) {
    if (!bonus1Target || !bonus2Target) return;

    const requestId = ++upsellRequestId;
    const signature = getOriginalCartSignature(cart);

    if (!signature) {
      lastUpsellRecommendationSignature = '';
      bonus1Target.innerHTML = '';
      bonus2Target.innerHTML = '';
      bonus1Target.dataset.loaded = 'false';
      bonus2Target.dataset.loaded = 'false';
      return;
    }

    if (
      signature === lastUpsellRecommendationSignature &&
      bonus1Target.dataset.loaded === 'true' &&
      bonus2Target.dataset.loaded === 'true'
    ) {
      return;
    }

    lastUpsellRecommendationSignature = signature;

    bonus1Target.dataset.loaded = 'false';
    bonus2Target.dataset.loaded = 'false';

    bonus1Target.innerHTML =
      '<article class="ps-upsell-loading">Loading Bonus 1 offers...</article>';

    bonus2Target.innerHTML =
      '<article class="ps-upsell-loading">Loading Bonus 2 offers...</article>';

    try {
      const products = await getRelatedProductsForCart(cart);

      if (requestId !== upsellRequestId) return;

      const bonus1Products = products.slice(0, UPSELLS_PER_BONUS);
      const bonus2Products = products.slice(UPSELLS_PER_BONUS, UPSELLS_PER_BONUS * 2);

      bonus1Target.innerHTML =
        bonus1Products
          .map(function (product) {
            return renderUpsellCard(product, '1', 5);
          })
          .join('') ||
        '<article class="ps-upsell-empty">No related Bonus 1 offers available.</article>';

      bonus2Target.innerHTML =
        bonus2Products
          .map(function (product) {
            return renderUpsellCard(product, '2', 10);
          })
          .join('') ||
        '<article class="ps-upsell-empty">No related Bonus 2 offers available.</article>';
    } catch (err) {
      console.error('Dynamic upsells failed:', err);

      bonus1Target.innerHTML =
        '<article class="ps-upsell-empty">No related Bonus 1 offers available.</article>';

      bonus2Target.innerHTML =
        '<article class="ps-upsell-empty">No related Bonus 2 offers available.</article>';
    } finally {
      bonus1Target.dataset.loaded = 'true';
      bonus2Target.dataset.loaded = 'true';
    }
  }

  function getEstimatedUpsellDiscountPercent(item) {
    const properties = item.properties || {};

    if ((item.line_level_total_discount || 0) > 0) return 0;
    if (properties['_ps_upsell_source'] !== 'cart_drawer') return 0;

    const discountPercent = Number(properties['_ps_discount_percent'] || 0);

    return Number.isFinite(discountPercent) ? discountPercent : 0;
  }

  function getDisplayLinePrice(item) {
    const discountPercent = getEstimatedUpsellDiscountPercent(item);

    if (!discountPercent) {
      return item.final_line_price;
    }

    return Math.round(item.final_line_price * (100 - discountPercent) / 100);
  }

  function getDisplayCartTotal(cart) {
    return cart.items.reduce(function (total, item) {
      return total + getDisplayLinePrice(item);
    }, 0);
  }

  function getLinePriceHtml(item) {
    const discountPercent = getEstimatedUpsellDiscountPercent(item);

    if (!discountPercent) {
      return formatMoney(item.final_line_price);
    }

    return `
      <s>${formatMoney(item.final_line_price)}</s>
      <strong>${formatMoney(getDisplayLinePrice(item))}</strong>
      <span class="ps-cart-item__discount-note">${discountPercent}% bonus applied</span>
    `;
  }
  // End Test

    function renderCart(cart) {
      lastCart = cart;

      cartCountEls.forEach(function (el) {
        el.textContent = cart.item_count + ' Items';
      });

      if (footerCountEl) {
        footerCountEl.textContent = cart.item_count + ' Items';
      }

      if (subtotalEl) {
        subtotalEl.textContent = formatMoney(getDisplayCartTotal(cart));
      }

      if (cartItemsContainer) {
        if (!cart.items.length) {
          cartItemsContainer.innerHTML = `
            <div class="ps-empty-cart">
              <p>Your cart is empty.</p>
            </div>
          `;
        } else {
          cartItemsContainer.innerHTML = cart.items
            .map(function (item) {
              const img = item.image ? item.image : '';

              return `
                <div class="ps-cart-item" data-line-key="${item.key}">
                  <div class="ps-cart-item__image">
                    ${img ? `<img src="${img}" alt="${item.product_title}">` : ''}
                  </div>

                  <div class="ps-cart-item__content">
                    <h3 class="ps-cart-item__title">${item.product_title}</h3>

                    <div class="ps-cart-item__meta">
                      ${getItemOptions(item)}
                    </div>

                    <div class="ps-cart-item__actions">
                      <div class="ps-cart-qty">
                        <button type="button" data-ps-line-minus>−</button>
                        <input type="number" value="${item.quantity}" min="1" data-ps-line-qty>
                        <button type="button" data-ps-line-plus>+</button>
                      </div>

                      <button type="button" class="ps-cart-remove" data-ps-line-remove>
                        Remove
                      </button>
                    </div>
                  </div>

                  <div class="ps-cart-item__price">
                    ${getLinePriceHtml(item)}
                  </div>
                </div>
              `;
            })
            .join('');
        }
      }

      updateFlowUI(cart);
      updateDecorateQuestion(cart);

      renderDynamicUpsells(cart).catch(function (err) {
        console.error('Upsell render failed:', err);

        if (bonus1Target) {
          bonus1Target.innerHTML =
            '<article class="ps-upsell-empty">No related Bonus 1 offers available.</article>';
        }

        if (bonus2Target) {
          bonus2Target.innerHTML =
            '<article class="ps-upsell-empty">No related Bonus 2 offers available.</article>';
        }
      });
      window.psRefreshDonationArea && window.psRefreshDonationArea(cart);
    }

    async function refreshCart(openAfterRefresh) {
      const cart = await getCart();
      renderCart(cart);

      if (openAfterRefresh) {
        openDrawer();
      }

      return cart;
    }

    async function changeLine(lineKey, quantity) {
      const res = await fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: lineKey,
          quantity: quantity
        })
      });

      const cart = await res.json();
      renderCart(cart);
    }

    function createAddToCartFormData(variantId, quantity, properties) {
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', quantity || 1);

      if (properties) {
        Object.keys(properties).forEach(function (key) {
          formData.append('properties[' + key + ']', properties[key]);
        });
      }

      return formData;
    }

    async function addVariantToCart(variantId, quantity, properties) {
      const res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json'
        },
        body: createAddToCartFormData(variantId, quantity, properties)
      });

      if (!res.ok) {
        throw new Error('Add to cart failed');
      }

      return await refreshCart(true);
    }

    document.addEventListener('click', async function (event) {
      const closeBtn = event.target.closest('[data-ps-cart-close]');
      if (closeBtn) {
        closeDrawer();
        return;
      }

      const cartLink = event.target.closest(
        'a[href="/cart"], a[href*="/cart"], a[href*="/cart?"], a[href*="/cart#"], a[href*="/cart?view="], a[href*="/cart.js"], #cart-icon-bubble'
      );

      if (cartLink) {
        const href = cartLink.getAttribute('href') || '';

        if (
          href.includes('/checkout') ||
          href.includes('/cart/add') ||
          href.includes('/cart/change') ||
          href.includes('/cart/update')
        ) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        await refreshCart(true);
        return;
      }

      const minusBtn = event.target.closest('[data-ps-line-minus]');
      if (minusBtn) {
        const item = minusBtn.closest('.ps-cart-item');
        const input = item.querySelector('[data-ps-line-qty]');
        const lineKey = item.getAttribute('data-line-key');
        const newQty = Math.max(1, parseInt(input.value, 10) - 1);

        await changeLine(lineKey, newQty);
        return;
      }

      const plusBtn = event.target.closest('[data-ps-line-plus]');
      if (plusBtn) {
        const item = plusBtn.closest('.ps-cart-item');
        const input = item.querySelector('[data-ps-line-qty]');
        const lineKey = item.getAttribute('data-line-key');
        const newQty = parseInt(input.value, 10) + 1;

        await changeLine(lineKey, newQty);
        return;
      }

      const removeBtn = event.target.closest('[data-ps-line-remove]');
      if (removeBtn) {
        const item = removeBtn.closest('.ps-cart-item');
        const lineKey = item.getAttribute('data-line-key');

        await changeLine(lineKey, 0);
        return;
      }

      const upsellMinus = event.target.closest('[data-ps-upsell-minus]');
      if (upsellMinus) {
        const card = upsellMinus.closest('.ps-upsell-card');
        const input = card.querySelector('.ps-upsell-qty input');
        input.value = Math.max(1, parseInt(input.value, 10) - 1);
        return;
      }

      const upsellPlus = event.target.closest('[data-ps-upsell-plus]');
      if (upsellPlus) {
        const card = upsellPlus.closest('.ps-upsell-card');
        const input = card.querySelector('.ps-upsell-qty input');
        input.value = parseInt(input.value, 10) + 1;
        return;
      }

      const declineBtn = event.target.closest('[data-ps-decline]');
      if (declineBtn) {
        hideFlowError();
        completeBonusStep(declineBtn.dataset.bonusStep);
        return;
      }

      const upsellAdd = event.target.closest('[data-ps-upsell-add]');
      if (upsellAdd) {
        const card = upsellAdd.closest('.ps-upsell-card');
        const variantSelect = card.querySelector('.ps-upsell-variant');
        const qtyInput = card.querySelector('.ps-upsell-qty input');

        const variantId = variantSelect.value;
        const qty = parseInt(qtyInput.value, 10) || 1;
        const step = upsellAdd.dataset.bonusStep;
        const tier = upsellAdd.dataset.bonusTier || (step === '2' ? 'Bonus 2' : 'Bonus 1');

        upsellAdd.disabled = true;
        upsellAdd.textContent = 'ADDING...';

        try {
          await addVariantToCart(variantId, qty, {
            '_ps_upsell_source': 'cart_drawer',
            '_ps_bonus_tier': tier,
            '_ps_discount_percent': upsellAdd.dataset.discount
          });

          hideFlowError();
          completeBonusStep(step);
          upsellAdd.textContent = 'ADDED';

          setTimeout(function () {
            upsellAdd.textContent = 'ADD TO CART';
            upsellAdd.disabled = false;
          }, 900);
        } catch (err) {
          console.error(err);

          upsellAdd.textContent = 'ERROR';

          setTimeout(function () {
            upsellAdd.textContent = 'ADD TO CART';
            upsellAdd.disabled = false;
          }, 1200);
        }

        return;
      }

      const checkoutBtn = event.target.closest('[data-ps-checkout]');
      if (checkoutBtn) {
        const cart = lastCart || await getCart();
        const flow = getFlowStateForCart(cart);

        if (!flow.hasCartItems) {
          showFlowError('Your cart is empty. Please add a product before checkout.');
          return;
        }

        if (!flow.bonus1Done) {
          showFlowError('Please add or decline the Bonus 1 offer before moving to Bonus 2.');
          if (bonus1Section) bonus1Section.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }

        if (!flow.bonus2Done) {
          showFlowError('Please add or decline the Bonus 2 offer before checkout.');
          if (bonus2Section) bonus2Section.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }

       const customizationRequired =
        decorateQuestion && !decorateQuestion.hidden;

        const selected =
          drawer.querySelector('input[name="ps_decorate_choice"]:checked') ||
          drawer.querySelector('input[name="decorate_choice"]:checked') ||
          document.querySelector('input[name="ps_decorate_choice"]:checked') ||
          document.querySelector('input[name="decorate_choice"]:checked');

        if (customizationRequired && !selected) {
          hideFlowError();

          if (decorateError) {
            decorateError.style.display = 'block';
          }

          return;
        }

        const decorateValue = selected ? selected.value : '';

        if (
          customizationRequired &&
          decorateValue !== 'Yes' &&
          decorateValue !== 'No'
        ) {
          if (decorateError) {
            decorateError.style.display = 'block';
          }

          return;
        }

        checkoutBtn.disabled = true;
        checkoutBtn.textContent = 'PROCESSING...';

        try {
          // Only save decoration value when we actually have Yes or No.
          if (decorateValue === 'Yes' || decorateValue === 'No') {
            const response = await fetch(root + 'cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({
                note: '',
                attributes: {
                  'Want to be decorated?': decorateValue
                }
              })
            });

            if (!response.ok) {
              throw new Error('Could not save decoration choice');
            }

            // Make sure Shopify finished updating cart
            await response.json();
          }

          if (decorateValue === 'Yes') {
            window.location.href = buildStorePath(PURCHASE_PROCESS_URL);
            return;
          }

          window.location.href = buildStorePath(CHECKOUT_URL);
          return;

        } 

        catch (err) {
          console.error('Checkout decoration save failed:', err);

          checkoutBtn.disabled = false;
          checkoutBtn.textContent = 'CHECKOUT';

          if (decorateError) {
            decorateError.textContent =
              'Could not save your selection. Please try again.';
            decorateError.style.display = 'block';
          }
        }
      }
    });

    document.addEventListener('change', async function (event) {
      const qtyInput = event.target.closest('[data-ps-line-qty]');
      if (qtyInput) {
        const item = qtyInput.closest('.ps-cart-item');
        const lineKey = item.getAttribute('data-line-key');
        const newQty = Math.max(1, parseInt(qtyInput.value, 10) || 1);

        await changeLine(lineKey, newQty);
      }

      const decorateRadio = event.target.closest('input[name="ps_decorate_choice"]');
      if (decorateRadio && decorateError) {
        decorateError.style.display = 'none';
      }
    });

    document.addEventListener(
      'submit',
      async function (event) {
        const form = event.target.closest('form[action*="/cart/add"]');

        if (!form) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        const submitBtn = form.querySelector('[type="submit"]');
        const originalText = submitBtn ? submitBtn.textContent : '';

        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Adding...';
        }

        try {
          const formData = new FormData(form);

          const res = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: {
              Accept: 'application/json'
            },
            body: formData
          });

          if (!res.ok) {
            throw new Error('Product add failed');
          }

          await refreshCart(true);
        } catch (err) {
          console.error(err);
          window.location.href = buildStorePath('/cart');
        } finally {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = originalText;
          }
        }
      },
      true
    );

    refreshCart(false);
  })();


